__turbopack_context__.v({
  "Black": "uqntyG_Black",
  "Button": "uqntyG_Button",
  "CardContent": "uqntyG_CardContent",
  "EventSubmissionPage": "uqntyG_EventSubmissionPage",
  "Heading": "uqntyG_Heading",
  "ImageContainer": "uqntyG_ImageContainer",
  "NextItemSameAsCurrent": "uqntyG_NextItemSameAsCurrent",
  "NoImage": "uqntyG_NoImage",
  "PhotoCredWrapReverse": "uqntyG_PhotoCredWrapReverse",
  "Reverse": "uqntyG_Reverse",
  "Root": "uqntyG_Root",
  "SameBackground": "uqntyG_SameBackground",
  "Text": "uqntyG_Text",
  "TransparentBackground": "uqntyG_TransparentBackground",
  "Visible": "uqntyG_Visible",
  "White": "uqntyG_White",
  "Wrap": "uqntyG_Wrap",
});
